import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Layout, Tabs, WordCloud } from '@utilities';

import NoDataPlaceholder from '../NoDataPlaceholder';
import OpenEndedTable from './components/OpenEndedTable';

const OpenEnded = ({ data, getResponseTextSummary, question }) => {
  const [selectedSegmentId, setSelectedSegmentId] = useState();

  useEffect(() => {
    setSelectedSegmentId(data?.segments?.[0].id);
  }, [data?.segments]);

  const groupSegment = data?.segments?.find((segment) => segment.id === selectedSegmentId);
  if (!groupSegment) return <NoDataPlaceholder />;

  const wordCloudData = groupSegment.chart?.series[0]?.data?.map((point) => ({ ...point })) || [];

  return (
    <Layout.Flex.Column>
      {data?.segments?.length > 1 && (
        <Tabs
          onChange={setSelectedSegmentId}
          options={data.segments.map(({ id, name }) => ({ label: name, value: id }))}
          value={selectedSegmentId}
        />
      )}
      <WordCloud data={wordCloudData} key={groupSegment.id} />
      {getResponseTextSummary({ question, segment: groupSegment })}
      <OpenEndedTable columns={groupSegment.table.columns} data={groupSegment.table.data} />
    </Layout.Flex.Column>
  );
};

OpenEnded.propTypes = {
  data: PropTypes.object,
  getResponseTextSummary: PropTypes.func,
  question: PropTypes.object,
};

export default OpenEnded;
